import {mapActions} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

import * as PRESCRIPTION from '@/store/constants/prescription';
import AuthUser from '@/mixins/authenticated-user';

import SearchMedicineAutoComplete from '@/views/Common/Medicine/SearchMedicineAutoComplete';

export default {
  inject: ['$validator'],
  props: {
    prescription: {
      type: Object
    },
    patient: {
      type: Object
    },
    mode: {
      type: String,
      default: 'edit'
    }
  },
  mixins: [AuthUser],

  computed: {
    defaultDate() {
      return moment().format('YYYY-MM-D');
    }
  },
  data() {
    return {
      item: {},
      reset: false
    }
  },

  components: {
    SearchMedicineAutoComplete,
    Datepicker
  },

  methods: {
    ...mapActions({
      updatePrescription: PRESCRIPTION.ACTION_UPDATE,
      addPrescription: PRESCRIPTION.ACTION_ADD,
    }),

    selectedMedicine(medicine) {
      this.item.medicine_id = medicine.key;
    },

    update() {
      this.item.id = this.prescription.id;
      this.updatePrescription(this.item).then(() => {
        this.$emit('prescriptionUpdated', true);
        this.clear();
        this.hide();
      }).catch(() => this.$emit('prescriptionUpdated', false));
    },

    add() {
      this.item.patient_id = this.patient.id;
      this.item.doctor_id = this.authUser.doctor.id;
      this.item.status = 'active';

      this.addPrescription(this.item).then(() => {
        this.$emit('prescriptionAdded', true);
        this.clear();
        this.hide();
      }).catch(() => this.$emit('prescriptionAdded', false));
    },

    clear() {
      this.item = {};
      this.reset = true;
    },

    validateForm(scope) {
      this.$validator.validateAll(scope).then((valid) => {
        console.log(valid, 'valid');
        if (valid) ((this.mode === 'edit') ? this.update() : this.add());
      });
    },

    hide() {
      this.$refs['prescriptionModal'].hide();
    }
  },

  watch: {
    prescription() {
      if (this.mode === 'edit') {
        this.item = this.prescription;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Prescription/js/prescription-modal.js